@if (!InProgress) {
  <div class="container-fluid g-0 head">
    <div class="row g-0">
      <div class="col">
        <h1>{{ "EXCEPTIONPAGE.H1.HEADER" | translate }}</h1>
      </div>
    </div>
  </div>
  <div class="container-fluid g-0 body">
    <div class="row g-0 transaction-status">
      <div class="col-auto">
        <img
          #img
          [src]="Model.SRC_IMG | imgsrc"
          (error)="img.alt = 'code:' + Model.SRC_IMG"
          />
      </div>
      <div class="col align-items-center d-flex">
        <h4 class="text-red">
          {{ "EXCEPTIONPAGE.H4.TITLE" | translate }}
        </h4>
      </div>
    </div>
    <div class="row g-0">
      <div class="col col-sm-6 col-md-4">
        <h4>
          {{ "EXCEPTIONPAGE.H4.ERROR" | translate }}
        </h4>
      </div>
      <div class="col">
        <h4>{{ Model.ErrorCode }} - {{ Model.ErrorMessage | translate }}</h4>
        <!-- <h4>{{ Model.ErrorCode }}</h4> -->
      </div>
    </div>
  </div>
  <div class="container-fluid g-0 footer">
    <div class="grid">
      <div class="g-col-md-4 g-col-12">
        <button type="button" class="btn btn-primary w-100" (click)="New()">
          <img
            [src]="'RESULTPAGE.IMG.HOME' | imgsrc"
            onerror="this.alt = 'code:RESULTPAGE.IMG.HOME'"
            />
          {{ "RESULTPAGE.BTN.NEW" | translate }}
        </button>
      </div>
    </div>
  </div>
}
